<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (severity of systemLogSeverities$ | async; track trackBy(severity)) {
      <lcs-option [value]="severity" id="lcs-option-id-{{ severity.severityId }}">
         {{ severity.name }}
      </lcs-option>
      }
   </div>
</ng-template>
